// import './App.css';
import { Navbar } from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes';

function App() {
  return (
    <div className="App">
      <Navbar />
      <AppRoutes />

      <br></br>
      <br></br>
      <br></br>
      <hr className="mt-6" />
      <Footer />
    </div>
  );
}

export default App;
